import { useEffect } from 'react';

export function useSettingsMode({ settingsMode, setKey }) {
	useEffect(() => {
		if (settingsMode) setKey('settings');
	}, [settingsMode]);
}
